exports.WP_CATEGORY = "WpCategory"
exports.IN_THIS_SPECIAL = "inThisSpecial"
exports.CATEGORIES_ENV_KEY = "_WP_CATEGORIES"

exports.SPECIAL_CATEGORIES = [285, 289, 295, 27091, 84795, 40043, 40043]
